webpackJsonp([70144966829960],{

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "contact" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "section",
	                null,
	                _react2.default.createElement(
	                    "form",
	                    { name: "contact", method: "post", "data-netlify": "true", "data-netlify-honeypot": "bot-field" },
	                    _react2.default.createElement("input", { type: "hidden", name: "form-name", value: "contact" }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "field half first" },
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "name" },
	                            "Name"
	                        ),
	                        _react2.default.createElement("input", { type: "text", name: "name", id: "name" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "field half" },
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "email" },
	                            "Email"
	                        ),
	                        _react2.default.createElement("input", { type: "text", name: "email", id: "email" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "field" },
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "message" },
	                            "Message"
	                        ),
	                        _react2.default.createElement("textarea", { name: "message", id: "message", rows: "6" })
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        { className: "actions" },
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("input", { type: "submit", value: "Send Message", className: "special" })
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("input", { type: "reset", value: "Clear" })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: "split" },
	                _react2.default.createElement(
	                    "section",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "contact-method" },
	                        _react2.default.createElement("span", { className: "icon alt fa-envelope" }),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "Email"
	                        ),
	                        _react2.default.createElement(
	                            "a",
	                            { href: "mailto:brianc@palaver.net?Subject=Email from Sunny Crest", target: "_blank" },
	                            "brianc@palaver.net"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "section",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "contact-method" },
	                        _react2.default.createElement("span", { className: "icon alt fa-phone" }),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "Phone"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "(219) 253-8181"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "section",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "contact-method" },
	                        _react2.default.createElement("span", { className: "icon alt fa-home" }),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "Map Search Address"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "8806 N. SR 71",
	                            _react2.default.createElement("br", null),
	                            "Earl Park, Indiana 47942",
	                            _react2.default.createElement("br", null),
	                            "USA"
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Contact;
	module.exports = exports["default"];

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Contact = __webpack_require__(80);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Generic = function Generic(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'Generic - Sunny Crest'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'Generic Page' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: 'alt' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            'Contact us'
	                        )
	                    ),
	                    _react2.default.createElement(_Contact2.default, null)
	                )
	            )
	        )
	    );
	};
	
	exports.default = Generic;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-80e5dba61457cf08ab93.js